import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  status: false,
});

let data;

const snippetReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.UPDATE_RESULT_FIELD_SNIPPET:
      data = action.payload;
      return state.set(data.field, data.value);

    case types.CHANGE_STATUS_GOOGLE_SNIPPET_RESULT:
      return state.set("status", !state.get("status"));

    case types.GET_SETTINGS_GOOGLE_SNIPPET_RESULT:
      data = action.payload;
      return state.set("status", data.on_off_google_snippet);

    default:
      return state;
  }
};

export default snippetReducer;
